// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../index';

import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const MagicLinkRequestDocument = `
    mutation magicLinkRequest($input: MagicLinkRequest!) {
  magicLinkRequest(input: $input)
}
    `;

export function useMagicLinkRequestMutation() {
  return Urql.useMutation<SchemaTypes.MagicLinkRequestMutation, SchemaTypes.MagicLinkRequestMutationVariables>(MagicLinkRequestDocument);
};